import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const KoFlagIcon = ({ size = '36' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <path
        d="M29.6936 -0.0087249H4.33651C3.37418 -0.00989016 2.43971 0.314764 1.68477 0.912527C0.793875 1.60914 0.210709 2.62746 0.0601796 3.74943C0.032721 3.93762 0.0183709 4.1275 0.0172119 4.31768V29.6606C0.0176381 30.536 0.284491 31.3904 0.782209 32.11C1.03545 32.4719 1.34107 32.794 1.68904 33.0657C2.44396 33.6605 3.37605 33.9848 4.33651 33.987H29.6936C30.8307 33.978 31.9186 33.5215 32.7227 32.7161C33.5267 31.9108 33.9824 30.821 33.9914 29.6821V4.3263C33.9881 3.18362 33.5349 2.08839 32.7302 1.27838C31.9255 0.468367 30.8344 0.00895726 29.6936 -0.000106719V-0.0087249ZM28.3269 6.19032L30.2137 8.83781L29.238 9.46203L27.3427 6.82313L28.3269 6.19032ZM26.7625 7.15892L30.8927 12.9533L29.8698 13.599L25.774 7.78742L26.7625 7.15892ZM28.3484 20.4223L29.3326 21.0508L27.4416 23.6897L26.4616 23.0698L28.3484 20.4223ZM26.4745 11.9201L27.4587 11.2916L29.3541 13.952L28.3742 14.5719L26.4745 11.9201ZM29.9128 21.3651L30.9013 21.9935L29.0017 24.6454L28.0174 24.0211L29.9128 21.3651ZM25.1852 8.12321L27.0805 10.7793L26.1006 11.4035L24.1967 8.75171L25.1852 8.12321ZM9.73456 8.75171L5.64303 14.5633L4.62015 13.9176L8.74607 8.12321L9.73456 8.75171ZM8.18306 7.78742L4.08723 13.599L3.06865 12.9533L7.19884 7.15892L8.18306 7.78742ZM5.94819 24.0427L4.96828 24.6669L3.06865 22.0151L4.05284 21.3866L5.94819 24.0427ZM5.65164 6.19461L6.64013 6.82313L2.54433 12.6347L1.52575 11.989L5.65164 6.19461ZM5.65164 28.7867L1.55581 22.9751L2.54433 22.3509L6.67452 28.1452L5.65164 28.7867ZM7.22893 27.831L5.3293 25.1835L6.31779 24.555L8.21315 27.2111L7.22893 27.831ZM8.74607 26.8452L4.65024 21.0336L5.63873 20.4094L9.76465 26.1994L8.74607 26.8452ZM23.8615 18.7821C23.5243 20.4875 22.566 22.0063 21.1729 23.0432C19.7798 24.0801 18.0515 24.561 16.3241 24.3925C14.5967 24.2239 12.9936 23.4179 11.8265 22.1311C10.6595 20.8443 10.0119 19.1688 10.0096 17.4304C10.0098 17.0542 10.0385 16.6786 10.0956 16.3068C10.3894 14.575 11.3226 13.0172 12.7099 11.9426C14.0972 10.868 15.8372 10.3551 17.5844 10.5058C19.3317 10.6565 20.9586 11.4597 22.1421 12.756C23.3256 14.0523 23.9792 15.7469 23.9732 17.5036C23.9732 17.9322 23.9358 18.36 23.8615 18.7821ZM24.2139 26.2339L26.1006 23.5864L27.0848 24.2106L25.1938 26.8495L24.2139 26.2339ZM25.7697 27.1981L27.665 24.5378L28.6535 25.1706L26.7539 27.8224L25.7697 27.1981ZM28.2925 28.8125L27.3126 28.1883L29.208 25.5278L30.1964 26.1607L28.2925 28.8125ZM30.5446 25.6441L29.5647 25.0242L31.4557 22.3638L32.4442 22.9923L30.5446 25.6441ZM31.4686 12.6218L29.5733 9.98293L30.5618 9.35441L32.4571 12.0019L31.4686 12.6218Z"
        fill="#F2F2F2"
      />
      <path
        d="M29.569 25.0244L30.5489 25.6443L32.4528 22.9968L31.4643 22.364L29.569 25.0244Z"
        fill="black"
      />
      <path
        d="M27.3212 28.1885L28.3011 28.8127L30.205 26.1609L29.2122 25.5323L27.3212 28.1885Z"
        fill="black"
      />
      <path
        d="M30.9055 22.0022L29.9213 21.3737L28.026 24.0341L29.0059 24.654L30.9055 22.0022Z"
        fill="black"
      />
      <path
        d="M27.6694 24.5421L25.7783 27.2025L26.7582 27.8224L28.6579 25.1706L27.6694 24.5421Z"
        fill="black"
      />
      <path
        d="M6.66581 6.8317L5.67732 6.20319L1.54712 12.0019L2.57 12.6433L6.66581 6.8317Z"
        fill="black"
      />
      <path
        d="M4.11309 13.6077L8.20891 7.79608L7.22041 7.17188L3.09021 12.9663L4.11309 13.6077Z"
        fill="black"
      />
      <path
        d="M5.66458 14.5719L9.76039 8.76035L8.7719 8.13184L4.646 13.9262L5.66458 14.5719Z"
        fill="black"
      />
      <path
        d="M30.8927 12.9663L26.7625 7.17188L25.774 7.79608L29.8699 13.6077L30.8927 12.9663Z"
        fill="black"
      />
      <path
        d="M27.1021 10.7923L25.211 8.13184L24.2225 8.76035L26.1222 11.4122L27.1021 10.7923Z"
        fill="black"
      />
      <path
        d="M29.354 13.9609L27.4587 11.3048L26.4745 11.929L28.3741 14.5808L29.354 13.9609Z"
        fill="black"
      />
      <path
        d="M30.2136 8.84654L28.3269 6.19904L27.3427 6.82755L29.238 9.46644L30.2136 8.84654Z"
        fill="black"
      />
      <path
        d="M29.5818 9.98307L31.4728 12.622L32.4527 12.0021L30.566 9.35455L29.5818 9.98307Z"
        fill="black"
      />
      <path
        d="M27.4416 23.6985L29.3326 21.0596L28.3484 20.4311L26.4617 23.0829L27.4416 23.6985Z"
        fill="black"
      />
      <path
        d="M26.1093 23.5867L24.2225 26.2342L25.1981 26.8498L27.0935 24.2109L26.1093 23.5867Z"
        fill="black"
      />
      <path
        d="M3.09021 22.0238L4.99414 24.6799L5.97404 24.0557L4.07871 21.3953L3.09021 22.0238Z"
        fill="black"
      />
      <path
        d="M5.34216 25.1922L7.2418 27.844L8.226 27.2241L6.33066 24.5637L5.34216 25.1922Z"
        fill="black"
      />
      <path
        d="M4.65881 21.0425L8.75463 26.8541L9.77751 26.2127L5.64731 20.4183L4.65881 21.0425Z"
        fill="black"
      />
      <path
        d="M1.56873 22.9836L5.66024 28.7952L6.68312 28.1538L2.55292 22.3594L1.56873 22.9836Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5721 16.703C22.1933 16.3893 21.7546 16.1564 21.2828 16.0185C20.808 15.8765 20.3094 15.8326 19.8172 15.8894C18.7299 16.0422 17.7456 16.6155 17.0752 17.4865C16.4133 18.3357 15.4523 18.8993 14.3891 19.0621C13.8372 19.142 13.2748 19.1039 12.7387 18.9502C12.1033 18.7868 11.5234 18.4552 11.0599 17.9901C10.5964 17.5251 10.2663 16.9437 10.1041 16.307C10.0471 16.6788 10.0184 17.0544 10.0182 17.4305C10.0204 19.169 10.668 20.8445 11.8351 22.1313C13.0022 23.418 14.6053 24.2241 16.3327 24.3926C18.0601 24.5612 19.7884 24.0803 21.1815 23.0434C22.5746 22.0064 23.5329 20.4876 23.8701 18.7823C23.6753 17.966 23.2195 17.2358 22.5721 16.703Z"
        fill="#0161AD"
      />
      <path
        d="M16.985 10.4996C15.3406 10.5053 13.7506 11.0902 12.4934 12.1519C11.2362 13.2136 10.392 14.6845 10.1085 16.3069C10.2706 16.9437 10.6007 17.5251 11.0642 17.9901C11.5278 18.4551 12.1076 18.7867 12.7431 18.9501C13.2791 19.1038 13.8416 19.142 14.3934 19.0621C15.4567 18.8993 16.4176 18.3357 17.0796 17.4865C17.7499 16.6155 18.7343 16.0422 19.8216 15.8894C20.3138 15.8325 20.8124 15.8765 21.2871 16.0185C21.759 16.1564 22.1977 16.3893 22.5765 16.703C23.2207 17.2371 23.6734 17.9671 23.8658 18.7823C23.9409 18.3559 23.9783 17.9237 23.9776 17.4908C23.9753 15.6351 23.2374 13.8562 21.9262 12.5453C20.615 11.2343 18.8377 10.4985 16.985 10.4996Z"
        fill="#E72300"
      />
    </svg>
  )
}

export default React.memo(KoFlagIcon)

KoFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}
